// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__zkNrZ","row":"Settings_row__J-4Ul","title":"Settings_title__gveO6"};